import React from 'react';
import { Card, Box, CardContent, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const StatCard = ({ icon, title, count, percentage, backgroundColor, onHide }) => (
  <Card
    sx={{
      borderRadius: 3,
      boxShadow: 6,
      px: 2,
      pt: 3,
      pb: 2,
      height: { xs: 150, sm: 130 }, // Adjust height based on screen size
      position: 'relative',
      overflow: 'hidden',
      transition: 'transform 0.2s ease-in-out',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: 10,
      },
    }}
  >
    {/* Close Button */}
    {onHide && (
      <IconButton
        size="small"
        onClick={onHide}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 1,
          color: '#999',
          '&:hover': { color: '#f44336' },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    )}

    {/* Icon Circle */}
    <Box
      sx={{
        position: 'absolute',
        top: 12,
        left: 12,
        backgroundColor,
        width: 48,
        height: 48,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: 28,
        boxShadow: 3,
      }}
    >
      {icon}
    </Box>

    {/* Content */}
    <CardContent
      sx={{
        marginLeft: 8,
        paddingLeft: { xs: 4, sm: 6 }, // Adjust padding for small screens
        paddingTop: { xs: 2, sm: 3 },
        paddingBottom: { xs: 1, sm: 2 },
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: 'text.secondary',
          fontWeight: 600,
          textTransform: 'uppercase',
          fontSize: { xs: 10, sm: 12 }, // Smaller font size for small screens
          lineHeight: 1.2,
        }}
      >
        {title}
      </Typography>

      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          mt: 1,
          fontSize: { xs: 22, sm: 28 }, // Adjust count size too
          color: 'text.primary',
        }}
      >
        {count}
      </Typography>

      {percentage !== undefined && (
        <Typography
          variant="body2"
          sx={{
            mt: 1,
            fontWeight: 500,
            fontSize: { xs: 11, sm: 13 }, // Make percentage text responsive
            color: percentage >= 0 ? '#43a047' : '#e53935',
            lineHeight: 1.3,
          }}
        >
          {percentage >= 0 ? `+${percentage.toFixed(2)}%` : `${percentage.toFixed(2)}%`} compared to last month
        </Typography>
      )}
    </CardContent>
  </Card>
);

export default StatCard;
